module.exports = __webpack_public_path__ + "static/media/chart-circle.f17159e3.svg";